import amoAdapter from "./adapters/amo";
import b24Adapter from "./adapters/b24";
import demoAdapter from "./adapters/demo";

const adapters = {
  amo: amoAdapter,
  b24: b24Adapter,
  demo: demoAdapter,
};

const isB24Host = () =>
  window.location.hostname.includes("panelactivityb24");

const isB24Path = () =>
  window.location.pathname.match(/^\/b24(?:\/|$)/);

const isDemoPath = () =>
  window.location.pathname.match(/^\/pa-demo(?:\/|$)/);

const hasB24Query = (params) =>
  ["DOMAIN", "domain", "member_id", "memberId", "APP_SID", "AUTH_ID", "PLACEMENT"].some(
    (key) => params.has(key)
  );

const getRequestedProvider = () => {
  const params = new URLSearchParams(window.location.search);
  const provider = params.get("provider") || params.get("crm") || "";

  if (!provider && isDemoPath()) {
    return "demo";
  }

  if (!provider && (window.location.pathname.match(/^\/p\/[^/]+/) || isB24Path() || isB24Host() || hasB24Query(params))) {
    return "b24";
  }

  return String(provider || "amo").toLowerCase();
};

const getAdapter = () => adapters[getRequestedProvider()] || amoAdapter;

const activityApi = {
  getProvider() {
    return getAdapter().provider;
  },

  getStorageScope() {
    return getAdapter().getStorageScope();
  },

  getLookup() {
    return getAdapter().getLookup();
  },

  getDayEvents(day, query = {}) {
    return getAdapter().getDayEvents(day, query);
  },

  getPeriodEvents(days, queryFactory = () => ({})) {
    return Promise.all(
      days.map((day) => this.getDayEvents(day, queryFactory(day)))
    );
  },

  getSettings() {
    return getAdapter().getSettings();
  },

  getPortalStatus() {
    return getAdapter().getPortalStatus();
  },

  supportsWazzup() {
    return typeof getAdapter().getWazzupConfig === "function";
  },

  getWazzupConfig(options = {}) {
    const adapter = getAdapter();

    if (typeof adapter.getWazzupConfig !== "function") {
      return Promise.resolve({ connected: false, unavailable: true });
    }

    return adapter.getWazzupConfig(options);
  },

  connectWazzup(apiKey) {
    const adapter = getAdapter();

    if (typeof adapter.connectWazzup !== "function") {
      return Promise.reject(new Error("Wazzup недоступен в демо-режиме"));
    }

    return adapter.connectWazzup(apiKey);
  },

  saveWazzupMappings(mappings) {
    const adapter = getAdapter();

    if (typeof adapter.saveWazzupMappings !== "function") {
      return Promise.reject(new Error("Wazzup недоступен в демо-режиме"));
    }

    return adapter.saveWazzupMappings(mappings);
  },
};

export default activityApi;
